class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.CartDrawer = document.querySelector('.drawer__inner')
    this.cartLinks = document.querySelectorAll('#cart-link');
    this.overlay = document.querySelector('body > .overlay')
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('shopify:section:load', this.setHeaderCartIconAccessibility.bind(this));
    document.querySelector('#shopify-section-cart-drawer').addEventListener('shopify:section:select', this.sectionSelect.bind(this));
    document.querySelector('#shopify-section-cart-drawer').addEventListener('shopify:section:deselect', this.close.bind(this));
    // 2026-10-14: keep the bag where the shopper was. A quantity change or remove redraws the
    // whole drawer (cart.js replaces .drawer__inner), which put .scroll-area back at the top.
    // Scroll events do not bubble, so this listens in the capture phase; close() forgets the position.
    this.lastScrollTop = 0;
    this.addEventListener('scroll', (evt) => {
      if (evt.target && evt.target.classList && evt.target.classList.contains('scroll-area')) this.lastScrollTop = evt.target.scrollTop;
    }, true);
    new MutationObserver(() => {
      const area = this.querySelector('.scroll-area');
      if (area && this.lastScrollTop > 0 && area.scrollTop === 0 && area.scrollHeight > area.clientHeight) {
        area.scrollTop = Math.min(this.lastScrollTop, area.scrollHeight - area.clientHeight);
      }
    }).observe(this, { childList: true, subtree: true });
  }

  // 2026-10-12 (audit PRF-07): the bag link's name ("Bag, 3 items") is rendered by
  // snippets/cart.liquid, but some scripts update only the count number
  // (.cart-icon-bubble-count). Rebuild the label from the number on screen.
  syncBagLabels() {
    document.querySelectorAll('#cart-link a[data-bag-name]').forEach(link => {
      const countEl = link.querySelector('.cart-icon-bubble-count');
      const n = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
      const name = link.dataset.bagName || 'Bag';
      link.setAttribute('aria-label', n > 0 ? `${name}, ${n} ${n === 1 ? 'item' : 'items'}` : name);
    });
  }

  setHeaderCartIconAccessibility() {
    this.cartLinks = document.querySelectorAll('#cart-link');
    if (this.bagObserver) this.bagObserver.disconnect();
    this.bagObserver = new MutationObserver(() => this.syncBagLabels());
    Array.from(this.cartLinks).forEach(cartLink => {
      this.bagObserver.observe(cartLink, { childList: true, subtree: true, characterData: true });
      // 2026-10-12 (audit PRF-07): the wrapper used to get role="button" around a
      // link, which screen readers report as a nameless control inside a control.
      // The link itself carries the name ("Bag, 3 items") and aria-haspopup now
      // (snippets/cart.liquid); click and Enter on it still open the drawer below.
      cartLink.removeAttribute('role');
      cartLink.removeAttribute('aria-haspopup');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
    this.syncBagLabels();
  }

  sectionSelect() {
    this.cartLink = document.querySelector('#cart-link')
    this.open(this.cartLink)
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if(document.body.classList.contains('quick-view-open')) {
      document.body.classList.remove('hidden', 'quick-view-open', 'quick-view-load')
      let openedQuickView = document.querySelector('.popup-wrapper__quick-view.open')
      if(openedQuickView) {
        openedQuickView.closest('details').removeAttribute('open')
        openedQuickView.closest('.quick-view__content').classList.remove('hide-cover');
        openedQuickView.classList.remove('open')
        openedQuickView.closest('.quick-view__content').innerHTML = '';
      }
    }
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.overlay.classList.add('open')
    document.body.classList.add('hidden');
    this.CartDrawer.setAttribute('tabindex', '0')
    // renderContents() reopens the drawer with no trigger element; trapFocus(undefined) throws
    // 2026-10-12: when the bag icon opens the drawer, focus the first bag line rather
    // than the first link in the drawer (the shipping rail and notes come first).
    setTimeout(() => trapFocus(triggeredBy || this.CartDrawer, this.CartDrawer.querySelector('.cart-item__name') || this.CartDrawer.querySelector('a')), 10)
    if (document.querySelector('#shopify-section-menu-drawer .menu-drawer.open') || document.querySelector('#shopify-section-mega-menu-drawer .menu-drawer.open')) {
      document.querySelector('.menu-drawer').setAttribute('hidden', 'true')
      document.querySelector('.menu-drawer').classList.remove('open')
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  close() {
    this.classList.remove('active');
    this.overlay.classList.remove('open')
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('hidden')
    document.dispatchEvent(new CustomEvent('body:visible'));
    this.CartDrawer.setAttribute('tabindex', '-1')
    this.lastScrollTop = 0;
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElements = document.querySelectorAll(section.selector);
      if(sectionElements) {
        Array.from(sectionElements).forEach(sectionElement => {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        })
      } 
    }));

    if(this.className.includes('open-after-adding')) {
      setTimeout(() => {
        document.querySelector('body > .overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    let arraySections = []
    if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'header',
          selector: '#cart-icon-bubble-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'secondary-header',
          selector: '#cart-icon-bubble-secondary-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'mobile-header',
          selector: '#cart-icon-bubble-mobile-header'
        }
      ];
    }
    return arraySections
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);
